export const alphNumMap = {
  "0": "a",
  "1": "b",
  "2": "c",
  "3": "d",
  "4": "e",
  "5": "f",
  "6": "g",
  "7": "h",
  "8": "i",
  "9": "j",
}
export const alphRoot = "aaaaa"

// Grow
export const growPath = "img_grow"
export const growFrameWidth = 760
export const growFrameHeight = 504
export const growFrameCount = 285

// Rotate
export const rotatePath = "img_rotate"
export const rotateFrameWidth = 938
export const rotateFrameHeight = 632
export const rotateFrameCount = 78

// 3D
export const threePath = "img_3d"
export const threeFrameWidth = 778
export const threeFrameHeight = 518
export const threeDegrees = 52
export const threeFrameCount = 13

export const colourScheme = {
  gold: "#efca7a",
  steel: "#759d9d",
  brick: "#b15644",
  silver: "#c5d9b6",
  ink: "#040402",
  pumpkin: "#cd752b",
  white: "#ffffff",
}

export const isProductionMode = process.env.NODE_ENV === "production"
